import styled from "@emotion/styled";
import { Affix, Button } from "antd";
import { FC } from "react";

interface UpdateCampaignProps {
  loading: boolean;
}

const UpdateCampaignFooter: FC<UpdateCampaignProps> = ({ loading }) => {

  return (
    <Affix offsetBottom={0}>
      <WrapperAll>
        <ButtonWrapper>
          <Button
            loading={loading}
            htmlType="submit"
            type="primary"
            style={{ width: 200 }}
          size="large"
          >
            บันทึกข่าวสารและโปรโมชั่น
          </Button>
        </ButtonWrapper>
      </WrapperAll>
    </Affix>
  );
};

export default UpdateCampaignFooter;

const ButtonWrapper = styled.div`
  max-width: 250px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const WrapperAll = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 10px;
  background-color: #fff;
  border-radius: 4px;
`;
